export const videosTeatro = [
  {
    titulo: "La Consulta",
    descripcion:
      "Ciclo de Teatro: Todavía algo que decir. Actúan: Luis Canduci Jorge Contegni Dirección: Paula Fanelli Guión: Silvia Perelis Realización: Rodrigo Noya Producción: Gerontovida 2021",
    genero: "teatro",
    url: "https://www.youtube.com/embed/EGVY_J736Zg",
    id: "1",
  },
  {
    titulo: "Sapo de su Pozo",
    descripcion:
      "Actúan: Laura Rivero Florencia Martelli Dirección: Silvia Perelis Guión: Silvia Perelis Realización: Rodrigo Noya Producción: Gerontovida 2021",
    genero: "teatro",
    url: "https://www.youtube.com/embed/gvTuqVuhcrk",
    id: "2",
  },
  {
    titulo: "Paloma y Roberto",
    descripcion:
      "Ciclo de Teatro: Todavía algo que decir. Actúan: Silvia Trawier Diego Semino Estefanía Revas Dirección: María Fernanda  Catullo Guión: Silvia Perelis Realización: Rodrigo Noya Producción: Gerontovida 2021",
    genero: "teatro",
    url: "https://www.youtube.com/embed/JQ_27CA4uaE",
    id: "3",
  },
  {
    titulo: "¿En que idioma hablo?",
    descripcion:
      "Ciclo de Teatro: Todavía algo que decir. Actúan: Mónica Selvaggi, Cynthia Menéndez, Mariela Rodríguez Dirección: María Fernanda Catullo Guión: Silvia Perelis Realización: Rodrigo Noya Producción: Gerontovida 2021",
    genero: "teatro",
    url: "https://www.youtube.com/embed/Kl44uXNZFqw",
    id: "4",
  },
  {
    titulo: "¿Me habla a mi?",
    descripcion:
      "Ciclo de Teatro: Todavía algo que decir. Actúan: Silvia Trawier, Mariela Rodríguez, Estefanía Revas Dirección: Silvia Perelis Guión: Silvia Perelis Realización: Rodrigo Noya Producción: Gerontovida 2021",
    genero: "teatro",
    url: "https://www.youtube.com/embed/On1-RorsxDc",
    id: "5",
  },
  {
    titulo: "El reclamo",
    descripcion:
      "Actúan: Silvia Trawer, Segundo Peñaranda. Dirección: Florencia Martelli. Guión: Silvia Perelis. Realización: Rodrigo Noya. Producción: Gerontovida 2023",
    genero: "teatro",
    url: "https://www.youtube.com/embed/wd2jUCj5Bn4?si=4RR61bThh2XRviod",
    id: "6",
  },
  {
    titulo: "La APADEJUHI",
    descripcion:
      "Actúan: Luis Canduci y Felipe Marsilla. Dirección: Florencia Martelli. Guión: Silvia Perelis. Realización: Rodrigo Noya. Producción: Gerontovida 2024",
    genero: "teatro",
    url: "https://www.youtube.com/embed/ogVXQ2zXJYw?si=x6RQVUAk8LXYCkSq",
    id: "7",
  },
  {
    titulo: "Tus agujeros",
    descripcion:
      "Actúan: Esther Freitas y Pablo De Nicotti. Dirección: Florencia Martelli. Guión: Silvia Perelis. Realización: Rodrigo Noya. Producción: Gerontovida 2024",
    genero: "teatro",
    url: "https://www.youtube.com/embed/RWga0jWFqyw?si=U993eGTGBoIjTI8t",
    id: "8",
  },
];

export const VideoNoticiasData = [
  {
    genero: "noticias",
    url: "https://www.youtube.com/embed/7b5lFvn9e5k?si=5bwt0x1WERYI2_gN",
    titulo: "La vida de los jubilados en abril de 2024",
    descripcion: " Crónica TV, 01/04/2024. Conducción Chiche Gelblung",
    caratula: "/imagenes/caratulas-noticias/chiche.png",
    id: 1,
  },
  {
    genero: "noticias",
    url: "https://www.youtube.com/embed/zp27DL6WcTg?si=q8iXKNE8RMXE7Y_3",
    titulo: "El haber de los jubilados dura 10 minutos",
    descripcion:
      "Dr. Eugenio Semino expone en la Cámara de Diputados de la Nación. 04-04-2024",
    caratula: "/imagenes/caratulas-noticias/diputados.png",
    id: 2,
  },

  {
    genero: "noticias",
    url: "https://www.youtube.com/embed/DcI23Sy3t64?si=ooKye7lCK1pxtCqN",
    titulo: "La voz del jubilado",
    descripcion: "Entrevista con Eugenio Semino. 26-04-2025",
    caratula:
      "https://res.cloudinary.com/dsw6fpqoz/image/upload/v1747427467/voz-jubilado_smxd85.png",
    id: 3,
  },
  {
    genero: "noticias",
    url: "https://www.youtube.com/embed/eqVasJwgpWA?si=3llCvNupV0A9qiZ9",
    titulo: "Es por acá",
    descripcion:
      "Entrevista con Eugenio Semino. Conducción: Federico Sánchez - Radio Chubut, 28-04-2025",
    caratula:
      "https://res.cloudinary.com/dsw6fpqoz/image/upload/v1747427464/por-aca_btnly0.png",
    id: 4,
  },
  {
    genero: "noticias",
    url: "https://www.youtube.com/embed/8v5hgkLjEhs?si=DS2PN5KZdNYhJw-W",
    titulo: "Resumen de noticias",
    descripcion: "Radio Alas San Juan 06-05-2025",
    caratula:
      "https://res.cloudinary.com/dsw6fpqoz/image/upload/v1747427431/alas_smkovu.png",
    id: 5,
  },
  {
    genero: "noticias",
    url: "https://www.youtube.com/embed/8v5hgkLjEhs?si=DS2PN5KZdNYhJw-W",
    titulo: "Radio UNR FM 103.3",
    descripcion: "10-05-2025",
    caratula:
      "https://res.cloudinary.com/dsw6fpqoz/image/upload/v1747427463/papa_yqdkch.png",
    id: 6,
  },
  {
    genero: "noticias",
    url: "https://www.youtube.com/embed/RHTkMq2UsUk?si=cZSqUndOdhAgmWRb",
    titulo: "Pañales: escándalo en PAMI",
    descripcion: "Programa Una Vuelta Más. TN 14-05-2025",
    caratula:
      "https://res.cloudinary.com/dsw6fpqoz/image/upload/v1747427463/pan%CC%83ales_ymqcqn.png",
    id: 7,
  },
];
